module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("\n            Users\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Add user")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content user-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "user",
    attrs: {
      "model": _vm.user,
      "rules": _vm.rules,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please select user role"
    },
    model: {
      value: (_vm.user.role),
      callback: function($$v) {
        _vm.$set(_vm.user, "role", $$v)
      },
      expression: "user.role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer",
      "prop": "customerId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please select customer"
    },
    model: {
      value: (_vm.user.customerId),
      callback: function($$v) {
        _vm.$set(_vm.user, "customerId", $$v)
      },
      expression: "user.customerId"
    }
  }, _vm._l((_vm.customers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('user')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('user')
      }
    }
  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d6d2ec0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/users/Add.vue
// module id = 1143
// module chunks = 2